
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M29.455 31.885v-1.218a4.909 4.909 0 00-2.474-4.262l-4.885-2.802M13.905 23.602L9.02 26.404a4.91 4.91 0 00-2.475 4.263v1.218"}}),_c('path',{attrs:{"d":"M18 25.364h0c-3.615 0-6.545-3.75-6.545-7.364v-3.273A6.546 6.546 0 0118 8.182h0a6.546 6.546 0 016.545 6.545V18c0 3.615-2.93 7.364-6.545 7.364z"}}),_c('circle',{attrs:{"cx":"18","cy":"18","r":"18"}})])])
          )
        }
      }
    